import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUploadSuccess = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 42,
	height: 41,
	viewBox: "0 0 42 41",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		filter: "url(#filter0_d_1665_42502)",
		children: [/* @__PURE__ */ _jsx("rect", {
			x: .5,
			width: 40,
			height: 40,
			rx: 10,
			fill: "white",
			shapeRendering: "crispEdges"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M18.3757 24.8749L13.709 20.2083L14.6048 19.3124L18.3757 23.0833L26.3757 15.0833L27.2715 15.9791L18.3757 24.8749Z",
			fill: "#40BAEC"
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("filter", {
		id: "filter0_d_1665_42502",
		x: .5,
		y: 0,
		width: 41,
		height: 41,
		filterUnits: "userSpaceOnUse",
		colorInterpolationFilters: "sRGB",
		children: [
			/* @__PURE__ */ _jsx("feFlood", {
				floodOpacity: 0,
				result: "BackgroundImageFix"
			}),
			/* @__PURE__ */ _jsx("feColorMatrix", {
				in: "SourceAlpha",
				type: "matrix",
				values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
				result: "hardAlpha"
			}),
			/* @__PURE__ */ _jsx("feOffset", {
				dx: 1,
				dy: 1
			}),
			/* @__PURE__ */ _jsx("feComposite", {
				in2: "hardAlpha",
				operator: "out"
			}),
			/* @__PURE__ */ _jsx("feColorMatrix", {
				type: "matrix",
				values: "0 0 0 0 0.0666667 0 0 0 0 0.541176 0 0 0 0 0.698039 0 0 0 0.23 0"
			}),
			/* @__PURE__ */ _jsx("feBlend", {
				mode: "normal",
				in2: "BackgroundImageFix",
				result: "effect1_dropShadow_1665_42502"
			}),
			/* @__PURE__ */ _jsx("feBlend", {
				mode: "normal",
				in: "SourceGraphic",
				in2: "effect1_dropShadow_1665_42502",
				result: "shape"
			})
		]
	}) })]
});
export default SvgUploadSuccess;
